
export default {
    namespaced:true,
    state: {
        /**后台当前tab */
        currentTab:'',
        /**tab操作目录 */
        tabOpertionLabel:'',
        /**返回上一级路由地址 */
        lastRoutePath:''
    },
    mutations: {
       /**切换tab */
       changeTab(state,value){
        state.currentTab=value;
       },
       /**更新操作目录 */
       changeOptlabel(state,value){
        state.tabOpertionLabel=value;
       },
       changePath(state,value){
        state.lastRoutePath=value;
       }
    },
    actions: {
       
    }
};